import { colFormRef } from './consts';

export default function(editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;
  const classPfx = c.classPfx;
  const style = c.defaultStyle
    ? `<style>
    .${pfx} {
      padding: 2px;
    }
    .${classPfx}-theme001 {
      background: rgba(0,0,0,.5);
      padding: 25px 22px;
      display: -ms-flexbox;
      display: flex;
      width: 100%;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -ms-flex-align: center;
      align-items: center;
    }
    .${classPfx}-theme002 {
      background: rgba(0,0,0,.5);
      padding: 16px;
      display: -ms-flexbox;
      display: flex;
      width: 100%;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -ms-flex-align: center;
      align-items: center;
    }


    .${classPfx}-theme001 {
      background: rgba(0, 0, 0, .2);
      padding: 25px 22px;
      display: -ms-flexbox;
      display: flex;
      width: 100%;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -ms-flex-align: center;
      align-items: center;
    }


    .${classPfx}-theme001>.form-group>input {
      height: 100%;
      background: #fff;
      border-radius: .5px;
      border: 0;
      display: block;
      width: 100%;
      padding: 10px 32px;
      font-size: 20px;
    }

    .${classPfx}-theme002 {
      background: rgba(0, 0, 0, .2);
      padding: 16px;
      display: -ms-flexbox;
      display: flex;
      width: 100%;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -ms-flex-align: center;
      align-items: center;
    }

    .${classPfx}-theme002>.form-group>input {
      height: 100%;
      background: #fff;
      border-radius: 0;
      border: 0;
      display: block;
      width: 100%;
      padding: 10px 20px 10px 45px;
      font-size: 16px;
      color: #555;
      font-weight: 400;
    }

    .${classPfx}-theme003 {
      background: rgba(0, 0, 0, 0.8);
      box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.15);
      border-radius: 3px;
      position: relative;
      padding: 40px;
      position: relative;
      display: flex;
      display: -ms-flexbox;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -ms-flex-align: center;
      align-items: center;
    }

    .${classPfx}-theme003>.form-group>input {
      background: #fff;
      border-radius: 3px;
      height: 60px;
      position: relative;
      padding: 10px 15px 10px 48px;
    }

    .${classPfx}-theme001>.form-group>.btn-search {
      height: 100%;
      width: 100%;
      background: #4272d7;
      white-space: nowrap;
      border-radius: .5px;
      font-size: 20px;
      color: #fff;
      transition: all .2s ease-out, color .2s ease-out;
      border: 0;
      cursor: pointer;
    }

    .${classPfx}-theme002>.form-group>.btn-search {
      height: 100%;
      width: 100%;
      background: #e67600;
      white-space: nowrap;
      border-radius: .5px;
      font-size: 20px;
      color: #fff;
      transition: all .2s ease-out, color .2s ease-out;
      border: 0;
      cursor: pointer;
      font-weight: 400;
    }

    .${classPfx}-theme003>.form-group>.btn-search {
      min-width: 100px;
      height: 60px;
      padding: 0 15px;
      background: #ff8300;
      white-space: nowrap;
      border-radius: 3px;
      font-size: 20px;
      color: #fff;
      transition: all .2s ease-out, color .2s ease-out;
      border: 0;
      cursor: pointer;
      font-weight: 400;
    }

    </style>`
    : '';

  if (c.blocks.indexOf(colFormRef) >= 0) {
    bm.add(colFormRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="50">
    <path d="M22,5.5 C22,5.2 21.5,5 20.75,5 L3.25,5 C2.5,5 2,5.2 2,5.5 L2,8.5 C2,8.8 2.5,9 3.25,9 L20.75,9 C21.5,9 22,8.8 22,8.5 L22,5.5 Z M21,8 L3,8 L3,6 L21,6 L21,8 Z" fill-rule="nonzero"></path>
    <path d="M22,10.5 C22,10.2 21.5,10 20.75,10 L3.25,10 C2.5,10 2,10.2 2,10.5 L2,13.5 C2,13.8 2.5,14 3.25,14 L20.75,14 C21.5,14 22,13.8 22,13.5 L22,10.5 Z M21,13 L3,13 L3,11 L21,11 L21,13 Z" fill-rule="nonzero"></path>
    <rect x="2" y="15" width="10" height="3"/>
</svg>
      <div>${c.labelColForm}</div>`,
      category: c.labelColFormCategory,
      content: `
        <form class="${pfx} form-inline" data-gjs="page-search-form" data-gjs-type="page-search-form" action="">
          <div class="form-group">
            <input name="field1" placeholder="Search here" class="form-control"/>
          </div>
          <div class="form-group">
            <input name="field2" type="text" placeholder="Search here" class="form-control"/>
          </div>
          <div class="form-group">
            <input name="field3" type="date" placeholder="Select date" class="form-control"/>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-search">Search</button>
          </div>
        </form>
        ${style}
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info">
        <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/forms-component-search-form" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.labelColForm
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
